var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 12c.21 0 .387-.07.53-.212a.71.71 0 0 0 .213-.525V2.486l1.412 1.4c.136.135.31.202.52.202A.695.695 0 0 0 6.8 3.37a.695.695 0 0 0-.204-.515L3.92.203A.652.652 0 0 0 3.68.046.83.83 0 0 0 3.4 0a.83.83 0 0 0-.279.046.652.652 0 0 0-.241.157L.204 2.855A.695.695 0 0 0 0 3.37a.695.695 0 0 0 .725.718c.21 0 .384-.067.52-.202l1.412-1.4v8.777a.71.71 0 0 0 .213.525.722.722 0 0 0 .53.212zm4 0a.7.7 0 0 0 .7-.7v-5a.7.7 0 0 0-.7-.7h-.1a.7.7 0 0 0-.7.7v5a.7.7 0 0 0 .7.7h.1zm3.8 0h.1a.7.7 0 0 0 .7-.7V8.7a.7.7 0 0 0-.7-.7h-.1a.7.7 0 0 0-.7.7v2.6a.7.7 0 0 0 .7.7z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortAsc);
export default __webpack_public_path__ + "static/media/table-sort-asc.ca0c00ea3864ed931c89bfe99b4fc79e.svg";
export { ForwardRef as ReactComponent };